var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',_vm._g(_vm._b({attrs:{"type":"info","size":"small"}},'el-button',_vm.$attrs,false),_vm.$listeners),[_c('jj-icons',{attrs:{"type":"refreshLeft"}}),_vm._v(" "+_vm._s(_vm.$t('buttons.reset'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }